// in gastby-browser.js
exports.shouldUpdateScroll = () => {
  setTimeout(() => {
    window.scrollTo(0, 0)
  })

  return false
}
